import { Timeline, TimelineItem, TimelineTitle } from "vue-cute-timeline";
import "vue-cute-timeline/dist/index.css";
import loading from "vue-loading";
import {
  addToFavorites,
  getChatgptMessage,
  getChatgptStat,
  askChatgpt,
  ruinChatgptMessage,
  precreateAlipay,
  checkOkAlipay,
  shareToSquare,
  deleteMsg,
  hideMsg,
  showMsg,
  getChatgptRoleConfig,
  uploadDocument,
  estimateDocumentTokens,
  askChatgptStream,
  searchChatgptMessages,
  getChatgptMessagePosition,
} from "../../../api";
import MathJax from "../../../common/MathJax";
import Grapheme from "grapheme-splitter";
// import loadJs from '../../../common/loadJs'
import { marked } from "marked"; // 正确引入marked
import CircleProgress from "js-circle-progress";
import QRCode from "qrcode";
import UsageBar from "../../../components/UsageBar";
import QuotaUsageBar from "../../../components/QuotaUsageBar";
import { api as viewerApi } from "v-viewer";
import * as imageConversion from "image-conversion";
import HyperDown from "hyperdown";
import Clipboard from "clipboard";
import {
  hasFeature,
  getModelDisplayName,
  getModelConfig,
  initModelConfigList,
  getContinuousDialogQuotUseBase,
  getAllFeatures,
} from "@/config/modelConfig";
import Prism from "prismjs";

// 主题选择（选择一个取消注释）
import "prismjs/themes/prism.css"; // 默认主题
// import "prismjs/themes/prism-dark.css";           // 深色主题
// import "prismjs/themes/prism-okaidia.css";        // Okaidia主题
// import "prismjs/themes/prism-twilight.css";       // 暮光之城主题
// import "prismjs/themes/prism-coy.css";            // Coy主题
// import "prismjs/themes/prism-solarizedlight.css"; // Solarized Light主题
// import "prismjs/themes/prism-tomorrow.css";       // Tomorrow Night主题

// 常用编程语言
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-typescript";
import "prismjs/components/prism-jsx";
import "prismjs/components/prism-python";
import "prismjs/components/prism-java";
import "prismjs/components/prism-kotlin";
import "prismjs/components/prism-go";
import "prismjs/components/prism-rust";
import "prismjs/components/prism-c";
import "prismjs/components/prism-cpp";
import "prismjs/components/prism-csharp";

// Web相关
import "prismjs/components/prism-markup"; // HTML
import "prismjs/components/prism-css";
import "prismjs/components/prism-scss";
import "prismjs/components/prism-sass";
import "prismjs/components/prism-less";
import "prismjs/components/prism-json";
import "prismjs/components/prism-yaml";
import "prismjs/components/prism-markdown";

// 服务器/脚本语言
import "prismjs/components/prism-ruby";
import "prismjs/components/prism-bash";
import "prismjs/components/prism-docker";
import "prismjs/components/prism-nginx";

// 数据库
import "prismjs/components/prism-sql";

// 引入插件（可选）
import "prismjs/plugins/line-numbers/prism-line-numbers.css";
import "prismjs/plugins/line-numbers/prism-line-numbers";

// import FrontVersionCheck from "../../../components/FrontVersionCheck";
// import "prismjs/components/prism-regex";
import html2pdf from "html2pdf.js";
import { saveAs } from "file-saver";

export default {
  metaInfo: {
    meta: [
      {
        name: "keyWords",
        content:
          "兮游,seayouth,兮游博客,seayouth博客,chatgpt,AI绘图,AI作品图集,AI语音,游戏模拟器", //变量或字符串
      },
      {
        name: "description",
        content:
          "专注于分享最新AI技术的博客平台，旨在为广大用户提供学习和交流的空间，打造一个有益于社区的平台",
      },
    ],
  },
  created() {
    this.initConfig();
  },

  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timerGetStat);
    clearInterval(this.timerGetCharge);
    clearInterval(this.timerRefreshAutoRecharge);
    delete window.copyCode;
    this.saveSelectedFeatures();
  },
  components: {
    Grapheme,
    MathJax,
    Timeline,
    TimelineItem,
    TimelineTitle,
    UsageBar,
    QuotaUsageBar,
  },
  data: function() {
    return {
      showPagination: true, // 控制分页显示状态
      activeIndex: null,
      continuousDialogQuotUse: "",
      continuousCount: 0,
      hiddenReasoningIds: this.getHiddenReasoningIds(),
      favoriteGroups: [
        { id: 1, name: "重要", color: "#d93025" },
        { id: 2, name: "工作", color: "#fa903e" },
        { id: 3, name: "学习", color: "#f9ab00" },
        { id: 4, name: "生活", color: "#188038" },
        { id: 5, name: "技术", color: "#007b83" },
        { id: 6, name: "娱乐", color: "#1a73e8" },
        { id: 7, name: "其他", color: "#a142f4" },
      ],
      // 流式数据缓存（当消息未就绪时暂存数据）
      streamCache: new Map(), // { messageId: { reasoning: string[], content: string[] } }
      reasoningCache: new Map(), // { messageId: { reasoning: string[] } }

      uploading: false,
      uploadedDocs: [], // 存储上传成功的文档信息
      language: "",
      parserHyperDown: new HyperDown(),
      imgBase64StrList: [],
      files: [],
      maxSize: 1024 * 1024 * 12, // 12M会进行压缩
      previewIMG: null,
      limit: 4,
      isPreview: false,
      type: 0, // 0 预览模式 1 列表模式 2 预览模式 + 上传按钮
      foldedDict: {},
      cascaderValue: [],
      cascaderOptions: [],
      quotaUsageBarStat: {
        maxNum: 0,
        remainNum: 0,
      },
      currentConversationNode: "node19",
      count: 0,
      current: 1,
      whichPage: 1,
      chatgptMessageList: [],

      heartBeat: null,
      input: "",
      isFollowLastOne: "true",
      timer: null,
      timerGetStat: null,
      timerGetCharge: null,
      timerRefreshAutoRecharge: null,
      autoRechargerMinuteNodeList: null,
      timerChargeCounter: 0,
      loading: false,
      isRunningPre: false,
      continuousBreakDialogVisible: false,
      successRateCircleDialogVisible: false,
      hotCircleDialogVisible: false,
      avgTimeCircleDialogVisible: false,
      continueAskQuotaDialogVisible: false,
      aiArtTipDialogVisible: false,
      chargeDialogVisible: false,
      ruinDialogVisible: false, // 用于控制销毁按钮表单对话框的开启和关闭
      shareDialogVisible: false, // 用于控制销毁按钮表单对话框的开启和关闭
      deleteMsgDialogVisible: false, // 用于控制销毁按钮表单对话框的开启和关闭
      shareItemId: "",
      deleteItemId: "",
      versionValue: "DEEPSEEK_R1",
      continuousDialogMaxNum: 1,
      chatgptMessageEmpty: {
        completionText: "",
        completionTextOrigin: "",
        reasoningText: "",
        reasoningTextOrigin: "",
        conversationId: "",
        createDate: "",
        finishDate: "",
        gptVersion: "",
        id: "",
        innerConversationId: "",

        msgId: "",
        parentMsgId: "",
        promptText: "",

        relatedNodeName: "",
        status: "SLASH",
        userId: "",
      },
      modelStats: null,
      versionOptions: [],
      splitter: new Grapheme(),
      emojiStrList: [
        "🍕",
        "🍔",
        "🍟",
        "🌭",
        "🍿",
        "🧂",
        "🥓",
        "🥚",
        "🍳",
        "🧇",
        "🥞",
        "🧈",
        "🍞",
        "🥐",
        "🥨",
        "🥯",
        "🥖",
        "🧀",
        "🥗",
        "🥙",
        "🥪",
        "🌮",
        "🌯",
        "🥫",
        "🍖",
        "🍗",
        "🥩",
        "🍠",
        "🥟",
        "🥠",
        "🥡",
        "🍱",
        "🍘",
        "🍙",
        "🍚",
        "🍛",
        "🍜",
        "🦪",
        "🍣",
        "🍤",
        "🍥",
        "🥮",
        "🍢",
        "🧆",
        "🥘",
        "🍲",
        "🍝",
        "🥣",
        "🥧",
        "🍦",
        "🍧",
        "🍨",
        "🍩",
        "🍪",
        "🎂",
        "🍰",
        "🧁",
        "🍫",
        "🍬",
        "🍭",
        "🍡",
        "🍮",
        "🍯",
        "🍼",
        "🥛",
        "🧃",
        "☕",
        "🍵",
        "🧉",
        "🍶",
        "🍾",
        "🍷",
        "🍸",
        "🍹",
        "🍺",
        "🍻",
        "🥂",
        "🥃",
        "🧊",
        "🥤",
        "🥢",
        "🍴",
        "🥄",
        "🏺",
        "🥝",
        "🥥",
        "🍇",
        "🍈",
        "🍉",
        "🍊",
        "🍋",
        "🍌",
        "🍍",
        "🥭",
        "🍎",
        "🍏",
        "🍑",
        "🍒",
        "🍓",
        "🍅",
        "🍆",
        "🌽",
        "🍄",
        "🥑",
        "🥒",
        "🥬",
        "🥦",
        "🥔",
        "🧄",
        "🧅",
        "🥕",
        "🌰",
        "🥜",
        "💐",
        "🌸",
        "🌹",
        "🌺",
        "🌻",
        "🌼",
        "🌷",
        "🥀",
        "🌱",
        "🌲",
        "🌳",
        "🌴",
        "🌵",
        "🌾",
        "🌿",
        "🍀",
        "🍁",
        "🍂",
        "🍃",
        "🎈",
        "🎆",
        "🎇",
        "🧨",
        "✨",
        "🎉",
        "🎊",
        "🎃",
        "🎄",
        "🎋",
        "🎍",
        "🎎",
        "🎏",
        "🎐",
        "🎑",
        "🧧",
        "🎀",
        "🎁",
        "🎠",
        "🎡",
        "🎢",
        "🎪",
        "🎨",
        "🎭",
        "🧵",
        "🧶",
        "⚽",
        "⚾",
        "🥎",
        "🏀",
        "🏐",
        "🏈",
        "🏉",
        "🎱",
        "🐵",
        "🐶",
        "🐺",
        "🐱",
        "🐯",
        "🦁",
        "🦒",
        "🦊",
        "🦝",
        "🐮",
        "🐷",
        "🐗",
        "🐭",
        "🐹",
        "🐰",
        "🐻",
        "🐨",
        "🐼",
        "🐸",
        "🦓",
        "🐴",
        "🦄",
        "🐔",
        "🐲",
        "🐽",
        "🐾",
        "🐒",
        "🦍",
        "🦧",
        "🦮",
        "🐕‍🦺",
        "🐩",
        "🐕",
        "🐈",
        "🐅",
        "🐆",
        "🐎",
        "🦌",
        "🦏",
        "🦛",
        "🐂",
        "🐃",
        "🐄",
        "🐖",
        "🐏",
        "🐑",
        "🐐",
        "🐪",
        "🐫",
        "🦙",
        "🦘",
        "🦥",
        "🦨",
        "🦡",
        "🐘",
        "🦔",
        "🐇",
        "🐢",
        "🐉",
        "🦕",
        "🦖",
        "🦦",
        "🦈",
        "🐬",
        "🐳",
        "🐋",
        "🐟",
        "🐠",
        "🐡",
        "🦐",
        "🦞",
        "🦀",
        "🐚",
        "🦆",
        "🐓",
        "🦃",
        "🦅",
        "🦢",
        "🦜",
        "🦩",
        "🦚",
        "🦉",
        "🐦",
        "🐧",
        "🐥",
        "🐤",
        "🐣",
        "🦋",
        "🐌",
        "🐝",
        "🐞",
      ],
      successRateCircle: null,
      hotCircle: null,
      avgTimeCircle: null,
      continueAskQuota: null,
      successRateCircleWeb: null,
      hotCircleWeb: null,
      avgTimeCircleWeb: null,
      continueAskQuotaWeb: null,
      autoRecoveryCircleWeb: null,
      autoRecoveryCircleMobile: null,
      autoRecoveryRemainSeconds: 0,
      chargeNum: 30,
      chargePrice: "1.00",
      qrcodeImgUrl: "",
      isShowQrcodeSuccessImg: false,
      chargeStageText: "等待发起订单",
      orderId: null,
      bonusNum: 0, // 购买配额奖励
      favoritesValue: 0,
      isSubmitDisabled: false,
      favoritesIconColor: "#000000",
      isDragOver: false,
      placeholder: "Enter: 换行 Ctrl+Enter: 发送",
      supportedImageTypes: ["jpg", "jpeg", "png", "gif", "webp", "bmp"],
      supportedDocTypes: [
        "pdf",
        "docx",
        "doc",
        "xlsx",
        "xls",
        "pptx",
        "ppt",
        "rtf",
        "txt",
        "py",
        "md",
        "html",
        "htm",
        "xml",
        "json",
        "yaml",
        "yml",
        "log",
        "sh",
        "bat",
        "epub",
        "java",
        "js",
        "ts",
        "cpp",
        "c",
        "h",
        "hpp",
        "cs",
        "go",
        "rs",
        "php",
        "rb",
        "swift",
        "kt",
        "scala",
        "r",
        "m",
        "ini",
        "conf",
        "cfg",
        "properties",
        "env",
        "toml",
        "svg",
        "css",
        "scss",
        "sass",
        "less",
        "ps1",
        "psm1",
        "bash",
        "zsh",
        "fish",
        "csv",
        "tsv",
        "sql",
        "tex",
        "rst",
        "adoc",
        "diff",
        "patch",
        "epub",
      ],
      showSearch: false, // 控制搜索框显示
      searchQuery: "", // 搜索关键词
      searchResults: [], // 搜索结果
      searchLoading: false, // 搜索加载状态
      searchDebounceTimer: null, // 搜索防抖定时器
      isSearchFocused: false, // 控制搜索结果的显示
      availableFeatures: [], // 所有可用的features
      selectedFeatures: [], // 初始化时从localStorage加载
      originalVersionOptions: [], // 保存原始的模型选项
      filteredVersionOptions: [], // 过滤后的模型选项
      recentlyUsedModels: [], // 最近使用的模型
    };
  },
  mounted() {
    this.loadRecentlyUsedModels();
    // 加载分页显示状态
    if (localStorage.getItem("chatgpt_showPagination") == null) {
      this.showPagination = true;
    } else {
      this.showPagination =
        localStorage.getItem("chatgpt_showPagination") == "true";
    }

    // 加载信息折叠缓存状态
    this.foldedDict = JSON.parse(localStorage.getItem("foldedDict"));
    if (this.foldedDict == null) {
      this.foldedDict = {};
    }
    if (localStorage.getItem("chatgpt_favoritesValue") == null) {
      this.favoritesValue = 0;
    } else {
      this.favoritesValue = parseInt(
        localStorage.getItem("chatgpt_favoritesValue")
      );
    }
    this.getChatgptStat();

    this.favoritesIconColor = this.getFavoritesIconColor(this.favoritesValue);
    this.versionValue = localStorage.getItem("chatgpt_versionValue");
    if (this.versionValue == null) {
      this.versionValue = "DEEPSEEK_R1";
    }
    this.isFollowLastOne = localStorage.getItem("chatgpt_isFollowLastOne");
    if (this.isFollowLastOne == null) {
      this.isFollowLastOne = "true";
    }
    this.selectOneVersion();

    this.continuousDialogMaxNum = localStorage.getItem(
      "chatgpt_continuousDialogMaxNum"
    );
    if (this.continuousDialogMaxNum == null) {
      this.continuousDialogMaxNum = 1;
    }

    this.successRateCircle = new CircleProgress(".successRateCircle", {
      value: 0,
      max: 100,
      textFormat: "percent",
    });
    this.hotCircle = new CircleProgress(".hotCircle", {
      value: 0,
      max: 6,
      textFormat: function(value, max) {
        return value;
      },
    });
    this.avgTimeCircle = new CircleProgress(".avgTimeCircle", {
      max: 120,
      value: 0,
      textFormat: function(value, max) {
        return value + " s";
      },
    });
    this.continueAskQuota = new CircleProgress(".continueAskQuota", {
      value: 0,
      max: 3,
      textFormat: "vertical",
      clockwise: true,
      animation: "none",
    });

    this.successRateCircleWeb = new CircleProgress(".successRateCircleWeb", {
      value: 0,
      max: 100,
      textFormat: "percent",
    });
    this.hotCircleWeb = new CircleProgress(".hotCircleWeb", {
      value: 0,
      max: 6,
      textFormat: function(value, max) {
        return value;
      },
    });
    this.avgTimeCircleWeb = new CircleProgress(".avgTimeCircleWeb", {
      value: 0,
      max: 120,
      textFormat: function(value, max) {
        return value + " s";
      },
    });
    this.continueAskQuotaWeb = new CircleProgress(".continueAskQuotaWeb", {
      value: 0,
      max: 3,
      textFormat: "vertical",
      clockwise: true,
      animation: "none",
    });
    this.autoRecoveryCircleWeb = new CircleProgress(".autoRecoveryCircleWeb", {
      value: 0,
      max: 100,
    });
    this.autoRecoveryCircleMobile = new CircleProgress(
      ".autoRecoveryCircleMobile",
      {
        value: 0,
        max: 100,
      }
    );

    // loadJs('ad','//pl18673378.highrevenuegate.com/051bd3799e3e3571f9a18102f0a1f9f6/invoke.js').then(()=>{
    //     // 加载成功，进行后续操作
    //     console.log("loadJs2")
    // }),

    this.loading = true;
    this.listChatgptMessageWithLoading();

    // gpt统计数据展示打开定时
    this.openIntervalGetStat();
    // 刷新自动恢复配额进度
    this.initAutoRechargerMinuteNodeList();
    if (this.autoRechargerMinuteNodeList != null) {
      this.openIntervalRefreshAutoRecharge();
      this.refreshAutoRecharge();
    }

    // 添加全局复制函数
    window.copyCode = async (button) => {
      const code = decodeURIComponent(button.getAttribute("data-code"));
      try {
        await navigator.clipboard.writeText(code);

        // 修改按钮文字显示复制成功
        const spanElement = button.querySelector("span");
        const originalText = spanElement.textContent;
        const iconElement = button.querySelector("i");

        // 修改图标和文字
        iconElement.className = "el-icon-check";
        spanElement.textContent = "已复制";
        button.style.color = "#49B1F5"; // 使用 Element UI 的成功色

        // 2秒后恢复原样
        setTimeout(() => {
          iconElement.className = "el-icon-document-copy";
          spanElement.textContent = originalText;
          button.style.color = "";
        }, 2000);

        // 显示 Element UI 的消息提示
        // this.$message({
        //   message: "复制成功",
        //   type: "success",
        //   duration: 2000,
        // });
      } catch (err) {
        this.$notify({
          message: "复制失败，请重试",
          type: "error",
          showClose: false,
          position: "bottom-right",
          duration: 2000,
        });
      }
    };
  },

  methods: {
    loadRecentlyUsedModels() {
      const models = localStorage.getItem("chatgpt_recentlyUsedModels");
      this.recentlyUsedModels = models ? JSON.parse(models) : [];
    },
    addRecentlyUsedModel(modelValue) {
      if (!modelValue) return;
      let models = this.recentlyUsedModels;
      const index = models.indexOf(modelValue);
      if (index > -1) {
        models.splice(index, 1);
      }
      models.unshift(modelValue);
      this.recentlyUsedModels = models.slice(0, 5);
      localStorage.setItem(
        "chatgpt_recentlyUsedModels",
        JSON.stringify(this.recentlyUsedModels)
      );
    },
    async retryMessage(item) {
      try {
        // 1. 删除失败的消息
        await this.clickRetryDeleteMsg(item.id);

        // 2. 重新发送相同的消息
        this.promptText = item.promptText;
        this.input = item.promptText;

        // 6. 重新发送
        await this.submitAsk();
      } catch (error) {
        console.error("重试失败:", error);
        this.$message.error("重试失败，请稍后再试");
      }
    },
    // 获取隐藏状态
    getHiddenReasoningIds() {
      const saved = localStorage.getItem("hiddenReasoningIds");
      return saved ? JSON.parse(saved) : [];
    },

    // 保存隐藏状态
    saveHiddenReasoningIds() {
      localStorage.setItem(
        "hiddenReasoningIds",
        JSON.stringify(this.hiddenReasoningIds)
      );
    },

    // 切换展开/隐藏状态
    toggleReasoning(messageId) {
      const index = this.hiddenReasoningIds.indexOf(messageId);
      if (index === -1) {
        this.hiddenReasoningIds.push(messageId);
      } else {
        this.hiddenReasoningIds.splice(index, 1);
      }
      this.saveHiddenReasoningIds();
    },

    // 检查是否隐藏
    isReasoningHidden(messageId) {
      return this.hiddenReasoningIds.includes(messageId);
    },
    initAutoRechargerMinuteNodeList() {
      if (this.$store.state.skillInfo == null) {
        return;
      }
      var chatgptVipLevel = this.$store.state.skillInfo.chatgptVipLevel;
      // console.log(chatgptVipLevel);
      if (chatgptVipLevel === 0) {
        this.autoRechargerMinuteNodeList = [0, 10, 20, 30, 40, 50, 60];
      } else if (chatgptVipLevel === 1) {
        this.autoRechargerMinuteNodeList = [0, 9, 18, 27, 36, 45, 54, 60];
      } else if (chatgptVipLevel === 2) {
        this.autoRechargerMinuteNodeList = [0, 8, 16, 24, 32, 40, 48, 56, 60];
      } else if (chatgptVipLevel === 3) {
        this.autoRechargerMinuteNodeList = [
          0,
          7,
          14,
          21,
          28,
          35,
          42,
          49,
          56,
          60,
        ];
      } else if (chatgptVipLevel === 4) {
        this.autoRechargerMinuteNodeList = [
          0,
          6,
          12,
          18,
          24,
          30,
          36,
          42,
          48,
          54,
          60,
        ];
      } else {
        this.autoRechargerMinuteNodeList = null;
      }
      // console.log(this.autoRechargerMinuteNodeList);
    },
    refreshAutoRecharge() {
      var date = new Date();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      var nextMinuteIndex = 0;
      for (var i = 0; i < this.autoRechargerMinuteNodeList.length - 1; i++) {
        if (
          this.autoRechargerMinuteNodeList[i] <= minutes &&
          this.autoRechargerMinuteNodeList[i + 1] > minutes
        ) {
          nextMinuteIndex = i + 1;
          break;
        }
      }
      var totalSeconds =
        (this.autoRechargerMinuteNodeList[nextMinuteIndex] -
          this.autoRechargerMinuteNodeList[nextMinuteIndex - 1]) *
        60;
      var remainSeconds =
        (this.autoRechargerMinuteNodeList[nextMinuteIndex] - minutes) * 60 -
        seconds;
      this.autoRecoveryRemainSeconds = remainSeconds;
      // console.log(totalSeconds);
      // console.log(remainSeconds);
      this.autoRecoveryCircleWeb.max = totalSeconds;
      this.autoRecoveryCircleWeb.value = totalSeconds - remainSeconds;
      this.autoRecoveryCircleMobile.max = totalSeconds;
      this.autoRecoveryCircleMobile.value = totalSeconds - remainSeconds;
    },
    downloadImageByUrl(imageFileUrl) {
      const reg = /[\[\]\*。、？！，,\.\?\! ]/g;
      const title = this.getNowFormatDate() + "-alipay-seayouth";
      this.onDownFile(imageFileUrl, title);
    },
    onDownFile(url, filename) {
      this.getBlob(url, (blob) => {
        this.saveAs(blob, filename);
      });
    },

    getNowFormatDate: function() {
      var date = new Date();
      var seperator1 = "_";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var hours = date.getHours();
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      var minutes = date.getMinutes();
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      var seconds = date.getSeconds();
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        seperator1 +
        hours +
        seperator1 +
        minutes +
        seperator1 +
        seconds;
      return currentdate;
    },

    getBlob(url, cb) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        if (xhr.status === 200) {
          cb(xhr.response);
        }
      };
      xhr.send();
    },

    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        var body = document.querySelector("body");

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        link.style.display = "none";
        body.appendChild(link);

        link.click();
        body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      }
    },

    // 移除单个文档
    removeDoc(index) {
      this.uploadedDocs.splice(index, 1);
      // this.updateInputWithCurrentDocs();
    },
    // 更新输入框中的文档信息
    updateInputWithCurrentDocs() {
      if (this.uploadedDocs.length === 0) {
        // 如果输入框中只有文档信息，则清空输入框
        if (this.input && this.input.trim().startsWith("文件：")) {
          this.input = "";
        }
        return;
      }
      const fileInfo = this.uploadedDocs
        .map(
          (doc) =>
            `文件：${doc.fileName} (${Math.round(doc.fileSize / 1024)}KB, ${
              doc.tokens
            } tokens)`
        )
        .join("\n");
      // 更新输入框中的文档信息
      if (this.input && this.input.trim().startsWith("文件：")) {
        this.input = fileInfo;
      } else {
        this.input = fileInfo + "\n" + this.input;
      }
    },

    translateVersion(version) {
      return getModelDisplayName(version);
    },

    handleHistoryClick(command) {
      this.input = command;
    },
    simplifyHistoryItem(promptText, num) {
      if (promptText.length > num) {
        return promptText.substring(0, num) + "...";
      }
      return promptText;
    },
    getRole() {
      if (this.$refs["cascader"] == null) {
        return "默认";
      }
      let nodesInfo = this.$refs["cascader"].getCheckedNodes();
      // console.log(nodesInfo);
      if (nodesInfo == null || nodesInfo[0] == null) {
        return "默认";
      }
      return nodesInfo[0].value;
    },

    handleChange(value) {
      localStorage.setItem(
        "ai_chatgpt_role_option",
        JSON.stringify(this.cascaderValue)
      );
      // console.log(value);
      // console.log(this.cascaderValue);
    },

    initConfig() {
      getChatgptRoleConfig()
        .then((res) => {
          this.cascaderOptions = res.data.options;
          this.cascaderValue = JSON.parse(
            localStorage.getItem("ai_chatgpt_role_option")
          );
          // console.log(this.cascaderValue)
        })
        .catch((err) => {});
      initModelConfigList(true).then((res) => {
        // 创建一个模型映射，用于快速查找模型信息
        this.allModelsMap = {};

        // 保存非禁用的模型列表
        this.originalVersionOptions = res
          .filter((model) => !model.disabled)
          .map((model) => {
            // 保存完整模型信息以便后续使用
            this.allModelsMap[model.modelKey] = model;

            return {
              value: model.modelKey,
              label: model.label,
              disabled: false,
            };
          });

        // 初始时，过滤后的模型与原始模型相同
        this.filteredVersionOptions = [...this.originalVersionOptions];

        // 获取所有可用的features
        this.availableFeatures = getAllFeatures();
        // console.log(this.availableFeatures);
        // 加载已选特性
        this.loadSelectedFeatures();
        this.filterModelsByFeatures();
      });
    },
    handleContinuousDialogMaxNumChange() {
      if (
        this.continuousDialogMaxNum == undefined ||
        this.continuousDialogMaxNum == null
      ) {
        this.continuousDialogMaxNum = 1;
      }
      localStorage.setItem(
        "chatgpt_continuousDialogMaxNum",
        this.continuousDialogMaxNum
      );
      this.getContinuousDialogQuotUse(this.continuousCount);
      if (this.continuousDialogMaxNum > 0) {
        localStorage.setItem(
          "chatgpt_preContinuousDialogMaxNum",
          this.continuousDialogMaxNum
        );
      }
    },
    clickUploadImgIcon() {
      this.$refs.imageUploader.click();
    },
    async handleImageUpload(event) {
      const files = event.target.files;
      if (!files.length) return;
      for (let file of files) {
        // 检查文件大小
        // console.log(file);
        // console.log(file.size);
        if (file.size > this.maxSize) {
          this.oversize(file);
          continue;
        }
        if (file.size > 1024 * 1024 * 1) {
          // 压缩图片
          try {
            const compressedFile = await imageConversion.compress(file, {
              quality: 0.8,
              type: "image/jpeg",
            });
            this.files.push({
              url: URL.createObjectURL(compressedFile),
              name: file.name,
            });
            this.getBase64(compressedFile).then((response) =>
              this.imgBase64StrList.push(response)
            );
          } catch (error) {
            this.$message.error("图片压缩失败");
            console.error("Image compression failed:", error);
          }
        } else {
          // 直接添加原图
          this.files.push({
            url: URL.createObjectURL(file),
            name: file.name,
          });
          this.getBase64(file).then((response) =>
            this.imgBase64StrList.push(response)
          );
        }
      }
      // 清空文件输入框的值，这样同一个文件可以重复选择
      event.target.value = "";
    },
    // 如果需要，可以添加一个检查文件类型的方法
    isImageFile(file) {
      return file.type.startsWith("image/");
    },
    getContinuousDialogQuotUse(continuousCount) {
      // 计算基础配额
      let baseQuota = getContinuousDialogQuotUseBase(
        this.versionValue,
        this.continuousDialogMaxNum,
        continuousCount
      );
      // 添加文档预估配额
      if (this.uploadedDocs && this.uploadedDocs.length > 0) {
        const docQuotas = this.uploadedDocs
          .map((doc) => doc.estimatedQuota)
          .filter((quota) => quota != null)
          .map((quota) => ` + ${quota}`);

        if (docQuotas.length > 0) {
          baseQuota += docQuotas.join("");
        }
      }
      this.continuousDialogQuotUse = baseQuota;
    },
    addToFavorites(id, favorites) {
      addToFavorites({
        id: id,
        favorites: favorites,
      })
        .then((res) => {
          // this.$toast({ type: "success", message: res.message });
          // this.shareDialogVisible = false;
          this.listChatgptMessage();
        })
        .catch((err) => {
          // this.shareDialogVisible = false;
          // this.$toast({ type: "error", message: err.message });
          this.$notify({
            message: err.message,
            type: "error",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
        });
    },
    switchFavorites(id) {
      this.favoritesValue = id;
      this.current = 1;
      this.loading = true;
      this.listChatgptMessageWithLoading();
      if (this.favoritesValue == 0) {
        this.isSubmitDisabled = false;
      } else {
        this.isSubmitDisabled = true;
      }
      localStorage.setItem("chatgpt_favoritesValue", this.favoritesValue);
      this.favoritesIconColor = this.getFavoritesIconColor(this.favoritesValue);

      this.getChatgptStat();
    },
    getFavoritesIconColor(favorites) {
      switch (favorites) {
        case 1:
          return "#d9302580";
        case 2:
          return "#fa903e80";
        case 3:
          return "#f9ab0080";
        case 4:
          return "#18803880";
        case 5:
          return "#007b8380";
        case 6:
          return "#1a73e880";
        case 7:
          return "#a142f480";
      }
    },
    getFavoritesIcon(item) {
      if (item.favorites == 0) {
        return "el-icon-star-off";
      } else {
        return "el-icon-star-on";
      }
    },
    getFoldIcon(item) {
      if (item.isFolded == 1) {
        return "el-icon-arrow-down";
      } else {
        return "el-icon-arrow-up";
      }
    },
    clickFoldIcon(item) {
      if (item.isFolded == 1) {
        item.isFolded = 0;
        this.foldedDict[item.id] = 0;
      } else {
        item.isFolded = 1;
        this.foldedDict[item.id] = 1;
      }
      localStorage.setItem("foldedDict", JSON.stringify(this.foldedDict));
    },
    handleCurrentChange(val) {
      this.current = Number(val);
    },
    hideMsg(itemId) {
      hideMsg({
        id: itemId,
      })
        .then((res) => {
          this.listChatgptMessage();
        })
        .catch((err) => {
          this.$notify({
            message: err.message,
            type: "error",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
        });
    },
    showMsg(itemId) {
      showMsg({
        id: itemId,
      })
        .then((res) => {
          this.listChatgptMessage();
        })
        .catch((err) => {
          this.$notify({
            message: err.message,
            type: "error",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
        });
    },
    copyData(itemId) {
      for (var i = 0; i < this.chatgptMessageList.length; i++) {
        if (this.chatgptMessageList[i].id == itemId) {
          //console.log(this.chatgptMessageList[i].completionTextOrigin);
          //console.log(this.chatgptMessageList[i].completionText);
          this.$copyText(this.chatgptMessageList[i].completionTextOrigin).then(
            (e) => {
              // this.$toast({ type: "success", message: "复制成功" });
              this.$notify({
                message: "复制原始文本成功！",
                type: "success",
                showClose: false,
                position: "bottom-right",
                duration: 2000,
              });
              return;
            },
            function(e) {
              // this.$toast({ type: "error", message: "复制失败" });
              this.$notify({
                message: "复制失败！",
                type: "error",
                showClose: true,
                position: "bottom-right",
                duration: 0,
              });
              return;
            }
          );
        }
      }
    },
    emptyMethod() {},

    clickDeleteMsg(itemId) {
      this.deleteItemId = itemId;
      this.deleteMsg();
    },
    deleteMsg() {
      deleteMsg({
        id: this.deleteItemId,
      })
        .then((res) => {
          // this.$toast({ type: "success", message: "删除成功" });
          this.$notify({
            message: "删除成功!",
            type: "success",
            showClose: false,
            position: "bottom-right",
            duration: 2000,
          });
          this.deleteMsgDialogVisible = false;
          this.listChatgptMessage();
        })
        .catch((err) => {
          this.deleteMsgDialogVisible = false;
          this.$notify({
            message: err.message,
            type: "error",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
          // this.$toast({ type: "error", message: err.message });
        });
    },
    async clickRetryDeleteMsg(itemId) {
      this.deleteItemId = itemId;
      await this.retryDeleteMsg();
    },
    async retryDeleteMsg() {
      deleteMsg({
        id: this.deleteItemId,
      })
        .then((res) => {})
        .catch((err) => {
          this.$notify({
            message: err.message,
            type: "error",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
        });
    },
    submitShareToSquare(itemId) {
      this.shareItemId = itemId;
      shareToSquare({
        id: this.shareItemId,
      })
        .then((res) => {
          // this.$toast({ type: "success", message: "分享成功" });
          this.$notify({
            message: "分享成功!",
            type: "success",
            showClose: false,
            position: "bottom-right",
            duration: 2000,
          });
          this.shareDialogVisible = false;
          this.listChatgptMessage();
        })
        .catch((err) => {
          this.shareDialogVisible = false;
          // this.$toast({ type: "error", message: err.message });
          this.$notify({
            message: err.message,
            type: "error",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
        });
    },
    clickChargeBtn() {
      this.chargeDialogVisible = true;
      this.qrcodeImgUrl = "";
      this.isShowQrcodeSuccessImg = false;
      this.chargeStageText = "等待发起订单";
    },
    closeChargeDialog() {
      clearInterval(this.timerGetCharge);
    },
    changeBonusNumByPrice() {
      if (this.chargePrice >= 20) {
        this.bonusNum = 100;
      } else if (this.chargePrice >= 16) {
        this.bonusNum = 70;
      } else if (this.chargePrice >= 12) {
        this.bonusNum = 45;
      } else if (this.chargePrice >= 8) {
        this.bonusNum = 25;
      } else if (this.chargePrice >= 4) {
        this.bonusNum = 10;
      } else {
        this.bonusNum = 0;
      }
    },

    chargeNumChangePrice() {
      this.chargePrice = (this.chargeNum / 30).toFixed(2);
      this.changeBonusNumByPrice();
    },
    chargePriceChangeNum() {
      this.chargePrice =
        ("" + this.chargePrice) // 第一步：转成字符串
          .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
      if (this.chargePrice > 20) this.chargePrice = 20;
      this.chargeNum = (this.chargePrice * 30).toFixed(0);
      this.changeBonusNumByPrice();
    },

    dealAskText: function(str) {
      str = str.trim();
      // if (str.indexOf("\n") != -1) {
      //   return "↵\n" + str;
      // } else {
      return str;
      // }
    },
    dealAskTextShorten: function(str) {
      str = str.trim();
      if (this.isMobile) {
        if (str.length > 20) {
          if (str.indexOf("\n") == -1) {
            str = str.substring(0, 20) + " ...";
          } else {
            str = str.substring(0, 20).substring(0, str.indexOf("\n")) + " ...";
          }
        }
      } else {
        if (str.length > 80) {
          if (str.indexOf("\n") == -1) {
            str = str.substring(0, 80) + " ...";
          } else {
            str = str.substring(0, 80).substring(0, str.indexOf("\n")) + " ...";
          }
        }
      }
      return str;
    },
    isLongText(str) {
      if (this.isMobile) {
        if (str.length > 20) {
          return true;
        }
      } else {
        if (str.length > 80) {
          return true;
        }
      }
      return false;
    },
    keyDown(e) {
      if (e.ctrlKey && e.keyCode == 13) {
        //用户点击了ctrl+enter触发
        // if(this.isSubmitDisabled){
        //   this.$toast({ type: "warnning", message: "请将收藏夹切换到默认收藏夹" });
        // }else{
        this.submitAsk();
        // }
      } else {
        //用户点击了enter触发
        this.textarea += "\n";
      }
    },
    clickRuinChatgptMessage() {
      ruinChatgptMessage().then((res) => {
        this.$notify({
          message: "清除信息成功!",
          type: "success",
          showClose: false,
          position: "bottom-right",
          duration: 2000,
        });
        // this.$toast({ type: "success", message: "清除信息成功" });
        this.ruinDialogVisible = false;
        this.listChatgptMessage();
      });
    },
    solveMathjax(str) {
      return str
        .replace(/\\\[/g, "$")
        .replace(/\\\]/g, "$")
        .replace(/\\\(/g, "$")
        .replace(/\\\)/g, "$");
    },
    solveMarkdownAndMathjax(str) {
      return this.parserHyperDown.makeHtml(str);
    },
    formatMath(id) {
      // console.log("formatMath");
      let that = this;
      setTimeout(function() {
        that.$nextTick(function() {
          if (MathJax.isMathjaxConfig) {
            //判断是否初始配置，若无则配置。
            MathJax.initMathjaxConfig();
          }
          MathJax.MathQueue(id); //传入组件id，让组件被MathJax渲染
        });
      }, 500);
    },
    selectOneVersion() {
      localStorage.setItem("chatgpt_versionValue", this.versionValue);
      var element = document.getElementById("continueAskQuotaCol");
      element.style.display = "block"; //让元素隐藏
      element = document.getElementById("continueAskQuotaColWeb");
      element.style.display = "block"; //让元素隐藏
      var element2 = document.getElementById("continueAskQuotaColWebCol");
      element2.style.width = "40px"; //让元素隐藏
      element2.style.margin = "0 0 8px 0";
      element2 = document.getElementById("continueAskQuotaColMobileCol");
      element2.style.width = "40px"; //让元素隐藏
      element2.style.margin = "0 8px 8px 0";

      this.updateModelStats(this.versionValue);
      // 获取预估配额
      this.updateDocsEstimatedQuota();
      this.getContinuousDialogQuotUse(this.continuousCount);
    },

    openIntervalGetStat() {
      if (this.timerGetStat) {
        clearInterval(this.timerGetStat);
      }
      this.timerGetStat = setInterval(this.getChatgptStat, 60000);
    },

    openIntervalRefreshAutoRecharge() {
      if (this.timerRefreshAutoRecharge) {
        clearInterval(this.timerRefreshAutoRecharge);
      }
      this.timerRefreshAutoRecharge = setInterval(
        this.refreshAutoRecharge,
        5000
      );
    },

    openIntervalGetChargeStatus() {
      // console.log("openIntervalGetChargeStatus");
      this.timerChargeCounter = 60;
      if (this.timerGetCharge) {
        clearInterval(this.timerGetCharge);
      }
      this.timerGetCharge = setInterval(this.getChargeStatus, 10000);
    },

    getChargeStatus() {
      // console.log(this.orderId)
      checkOkAlipay({
        orderId: this.orderId,
      })
        .then((res) => {
          this.$notify({
            message: "购买配额成功!",
            type: "success",
            showClose: false,
            position: "bottom-right",
            duration: 2000,
          });
          // this.$toast({ type: "success", message: "购买配额成功" });
          this.chargeStageText = "购买配额成功";
          this.qrcodeImgUrl = false;
          this.isShowQrcodeSuccessImg = true;
          this.getChatgptStat();
          clearInterval(this.timerGetCharge);
        })
        .catch((err) => {
          // console.log("定时等待支付");
        });
    },

    openIntervalList() {
      // console.log("openIntervalList");
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(this.listChatgptMessage, 10000);
    },

    closeIntervalList() {
      // console.log("closeIntervalList");
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    setFollowSwitchChange(isOn) {
      if (isOn) {
        if (this.isFollowLastOne == "true") {
          return;
        }
        this.isFollowLastOne = "true";
      } else {
        if (this.isFollowLastOne == "false") {
          return;
        }
        this.isFollowLastOne = "false";
      }
      localStorage.setItem("chatgpt_isFollowLastOne", this.isFollowLastOne);
      if (this.isFollowLastOne == "true") {
        // this.$toast({ type: "success", message: "已 打开 连续会话。" });
        // 设置连续会话长度为原来的大小
        if (localStorage.getItem("chatgpt_preContinuousDialogMaxNum") != null) {
          this.continuousDialogMaxNum = localStorage.getItem(
            "chatgpt_preContinuousDialogMaxNum"
          );
        } else {
          this.continuousDialogMaxNum = 3;
        }
        localStorage.setItem(
          "chatgpt_continuousDialogMaxNum",
          this.continuousDialogMaxNum
        );
      } else {
        // 设置连续会话长度为1
        localStorage.setItem(
          "chatgpt_preContinuousDialogMaxNum",
          this.continuousDialogMaxNum
        );
        this.continuousDialogMaxNum = 1;
        localStorage.setItem(
          "chatgpt_continuousDialogMaxNum",
          this.continuousDialogMaxNum
        );
      }
      this.getContinuousDialogQuotUse(this.continuousCount);
    },
    followSwitchChange() {
      localStorage.setItem("chatgpt_isFollowLastOne", this.isFollowLastOne);
      if (this.isFollowLastOne == "true") {
        // this.$toast({ type: "success", message: "已 打开 连续会话。" });
        // 设置连续会话长度为原来的大小
        if (localStorage.getItem("chatgpt_preContinuousDialogMaxNum") != null) {
          this.continuousDialogMaxNum = localStorage.getItem(
            "chatgpt_preContinuousDialogMaxNum"
          );
        } else {
          this.continuousDialogMaxNum = 3;
        }
        localStorage.setItem(
          "chatgpt_continuousDialogMaxNum",
          this.continuousDialogMaxNum
        );
        this.$notify({
          title: "已开启连续会话",
          message:
            "AI将记住上下文对话历史。当前所设置的最大会话长度为：" +
            this.continuousDialogMaxNum,
          type: "success",
          showClose: false,
          position: "bottom-right",
          duration: 2000,
        });
      } else {
        // this.$toast({
        //   type: "success",
        //   message: "已 关闭 连续会话。点击发送会重起新的会话",
        // });
        this.$notify({
          title: "已关闭连续会话",
          message: "发送新消息将会重起新的会话",
          type: "info",
          showClose: false,
          position: "bottom-right",
          duration: 2000,
        });
        // 设置连续会话长度为1
        localStorage.setItem(
          "chatgpt_preContinuousDialogMaxNum",
          this.continuousDialogMaxNum
        );
        this.continuousDialogMaxNum = 1;
        localStorage.setItem(
          "chatgpt_continuousDialogMaxNum",
          this.continuousDialogMaxNum
        );
      }
      this.getContinuousDialogQuotUse(this.continuousCount);
    },

    getChatgptStat() {
      getChatgptStat().then((res) => {
        // 处理统计数据
        this.dealStatistics(res);
      });
    },

    listChatgptMessage() {
      getChatgptMessage({
        pageNo: this.current,
        pageSize: this.$store.state.configInfo.chatgpt.pageSize,
        favorites: this.favoritesValue,
      }).then((res) => {
        this.continuousCount = res.extra.continuousCount;
        this.getContinuousDialogQuotUse(this.continuousCount);
        var isRunning = false;
        res.data.records.forEach((item) => {
          if (item.id in this.foldedDict) {
            item.isFolded = this.foldedDict[item.id];
          } else {
            item.isFolded = 0;
            this.foldedDict[item.id] = 0;
          }
        });
        this.chatgptMessageList = res.data.records;
        this.chatgptMessageList.forEach((item) => {
          if (item.completionText != null) {
            item.completionText = item.completionText.trim();
            item.completionTextOrigin = item.completionText;
            item.reasoningTextOrigin = item.reasoningText;
            item.streamingText = "";
            item.streamingTextOrigin = "";

            item.completionText = this.dealMarkdownBlock(
              item.id,
              item.completionTextOrigin,
              true
            );
            if (item.reasoningText != null) {
              item.reasoningText = this.dealMarkdownBlock(
                item.id,
                item.reasoningTextOrigin,
                true
              );
            }
          }
          item.color = this.checkIfAnswer(item.status);
          if (item.status == "RUNNING") {
            isRunning = true;
            // 10s一个emoji
            var emojiNum = parseInt(
              (new Date().getTime() - new Date(item.createDate).getTime()) /
                1000 /
                10
            );
            if (emojiNum > 60) emojiNum = 60;
            var key = "Chatgpt-" + item.id;
            var emojiValue;
            if (localStorage.getItem(key) != null) {
              emojiValue = localStorage.getItem(key);
              var tempNum = this.splitter.splitGraphemes(emojiValue).length;
              if (emojiNum <= tempNum) {
              } else {
                var deltaLength = emojiNum - tempNum;
                emojiValue += this.generateEmoji(deltaLength);
                localStorage.setItem("Chatgpt-" + item.id, emojiValue);
              }
            } else {
              emojiValue = this.generateEmoji(emojiNum);
              localStorage.setItem("Chatgpt-" + item.id, emojiValue);
            }
            item.completionText = emojiValue;
          } else {
            //清除缓存的emoji
            var key = "Chatgpt-" + item.id;
            if (localStorage.getItem(key) != null) {
              localStorage.removeItem(key);
            }
          }

          // if (item.status == "RECEIVING") {
          //   isRunning = true;
          // }
        });
        var newList = [];
        for (let i = 0; i < this.chatgptMessageList.length; ++i) {
          newList.push(this.chatgptMessageList[i]);
          if (i >= this.chatgptMessageList.length - 1) {
            continue;
          }
          if (
            this.chatgptMessageList[i].conversationId == null ||
            this.chatgptMessageList[i].conversationId !=
              this.chatgptMessageList[i + 1].conversationId
          ) {
            var newChatgptMessageEmpty = JSON.parse(
              JSON.stringify(this.chatgptMessageEmpty)
            );
            newChatgptMessageEmpty.id = i;
            newList.push(newChatgptMessageEmpty);
          }
        }
        this.chatgptMessageList = newList;
        this.count = res.data.total;
        if (isRunning == true) {
          if (this.isRunningPre != true) {
            this.isRunningPre = isRunning;
            this.openIntervalList();
          }
        } else {
          if (this.isRunningPre == true) {
            this.isRunningPre = isRunning;
            this.closeIntervalList();
            // 数据接收结束，结束定时获取之后，触发一次刷新配额数据
            this.getChatgptStat();
            // this.$nextTick(() => {
            //   this.attachClipboard();
            // });
          }
        }
      });
    },

    attachClipboard() {
      // const codeElement = document.querySelector(".clipboard-bound");
      // if (codeElement) {
      //   const classNames = codeElement.className.split(" "); // 将类名分割成数组
      //   this.language = classNames[0].split("-")[1];
      // }
      const codes = document.querySelectorAll(
        "pre > code:not(.clipboard-bound)"
      );
      // console.log(codes);
      codes.forEach((code) => {
        const button = document.createElement("button");
        button.textContent = "Copy";
        button.className = "copy-button";

        // 创建一个包含按钮和代码块的容器 div
        const container = document.createElement("div");
        container.className = "code-container";

        // 将按钮和代码块放入容器中
        container.appendChild(button);
        code.parentNode.insertBefore(container, code);
        container.appendChild(code);

        code.classList.add("clipboard-bound");

        const clipboard = new Clipboard(button, {
          target: () => code,
        });

        clipboard.on("success", (event) => {
          event.clearSelection();
          button.textContent = "Copied!";
          button.className = "copied-button";
          setTimeout(() => {
            button.textContent = "Copy";
            button.className = "copy-button";
          }, 800);
        });

        clipboard.on("error", () => {
          button.textContent = "请使用Ctrl+C进行拷贝";
        });
      });
    },
    dealStatistics: function(res) {
      if (res.data.userQuato == null) {
        this.quotaUsageBarStat.remainNum = 0;
        this.quotaUsageBarStat.maxNum = 0;
      } else {
        this.quotaUsageBarStat.remainNum = res.data.userQuato.remainNum;
        this.quotaUsageBarStat.maxNum = res.data.userQuato.maxNum;
      }

      // 配额数据
      if (res.data.chatgptQuato) {
        this.continueAskQuota.max = res.data.chatgptQuato.maxNum;
        this.continueAskQuota.value = res.data.chatgptQuato.remainNum;
        this.continueAskQuotaWeb.max = res.data.chatgptQuato.maxNum;
        this.continueAskQuotaWeb.value = res.data.chatgptQuato.remainNum;
      }

      // 获取当前选中的模型
      const currentModel = this.versionValue;
      this.modelStats = res.data.modelStats;
      this.updateModelStats(currentModel);
    },

    updateModelStats(currentModel) {
      if (!this.modelStats) {
        return;
      }
      const currentModelStats = this.modelStats[currentModel] || {
        successRate: 100,
        hotRate: 0,
        avgTime: 0,
      };

      // 更新统计数据
      this.successRateCircle.value = currentModelStats.successRate;
      this.hotCircle.value = currentModelStats.hotRate;
      this.avgTimeCircle.value = Math.floor(currentModelStats.avgTime);

      // Web端统计数据
      this.successRateCircleWeb.value = currentModelStats.successRate;
      this.hotCircleWeb.value = currentModelStats.hotRate;
      this.avgTimeCircleWeb.value = Math.floor(currentModelStats.avgTime);
    },

    generateEmoji: function(length) {
      var str = "";

      // var str2 = "";
      // for(var i =0; i < this.emojiStrList.length; i++){
      //   str2 += this.emojiStrList[i];
      // }
      // console.log(str2);

      for (var i = 0; i < length; i++) {
        str += this.emojiStrList[
          Math.floor(Math.random() * this.emojiStrList.length)
        ];
      }
      // console.log(str);
      return str;
    },

    dealStrWithCode: function(inStr) {
      var str = inStr.trim();
      var outStr = "";
      var str1 = "";
      var str2 = "";
      for (var i = 0; i < 10; i++) {
        outStr = outStr + str1 + str2;
        var flagBegin = str.indexOf("```");
        var flagEnd = str.indexOf("```", flagBegin + 3);
        if (flagBegin == -1 || flagEnd == -1) {
          outStr += str;
          break;
        }
        str1 = str.substring(0, flagBegin);
        str2 = str.substring(flagBegin, flagEnd);
        str2 = str2.substring(str2.indexOf("\n") + 1);
        // str2 = marked.parse(str2);
        str2 = "<pre><code>" + str2 + "</code></pre>";
        str = str.substring(flagEnd + 3).trim();
      }
      return outStr;
    },
    routeUrl(url) {
      this.$router.push({
        path: url,
      });
    },
    openUrlNewWindow(url) {
      window.open(url, "_blank");
    },
    listChatgptMessageWithLoading() {
      getChatgptMessage({
        pageNo: this.current,
        pageSize: this.$store.state.configInfo.chatgpt.pageSize,
        favorites: this.favoritesValue,
      })
        .then((res) => {
          var isRunning = false;
          this.continuousCount = res.extra.continuousCount;
          this.getContinuousDialogQuotUse(this.continuousCount);
          res.data.records.forEach((item) => {
            if (item.id in this.foldedDict) {
              item.isFolded = this.foldedDict[item.id];
            } else {
              item.isFolded = 0;
              this.foldedDict[item.id] = 0;
            }
          });
          this.chatgptMessageList = res.data.records;
          this.chatgptMessageList.forEach((item) => {
            if (item.completionText != null) {
              item.completionText = item.completionText.trim();
              item.completionTextOrigin = item.completionText;
              item.reasoningTextOrigin = item.reasoningText;
              item.streamingText = "";
              item.streamingTextOrigin = "";

              item.completionText = this.dealMarkdownBlock(
                item.id,
                item.completionTextOrigin,
                true
              );

              if (item.reasoningText != null) {
                item.reasoningText = this.dealMarkdownBlock(
                  item.id,
                  item.reasoningTextOrigin,
                  true
                );
              }
            }
            item.color = this.checkIfAnswer(item.status);
            if (item.status == "RUNNING") {
              isRunning = true;
              // 10s一个emoji
              var emojiNum = parseInt(
                (new Date().getTime() - new Date(item.createDate).getTime()) /
                  1000 /
                  10
              );
              if (emojiNum > 60) emojiNum = 60;
              var key = "Chatgpt-" + item.id;
              var emojiValue;
              if (localStorage.getItem(key) != null) {
                emojiValue = localStorage.getItem(key);
                var tempNum = this.splitter.splitGraphemes(emojiValue).length;
                if (emojiNum <= tempNum) {
                } else {
                  var deltaLength = emojiNum - tempNum;
                  emojiValue += this.generateEmoji(deltaLength);
                  localStorage.setItem("Chatgpt-" + item.id, emojiValue);
                }
              } else {
                emojiValue = this.generateEmoji(emojiNum);
                localStorage.setItem("Chatgpt-" + item.id, emojiValue);
              }
              item.completionText = emojiValue;
            } else {
              //清除缓存的emoji
              var key = "Chatgpt-" + item.id;
              if (localStorage.getItem(key) != null) {
                localStorage.removeItem(key);
              }
            }
            // if (item.status == "RECEIVING") {
            //   isRunning = true;
            // }
          });
          var newList = [];
          for (let i = 0; i < this.chatgptMessageList.length; ++i) {
            newList.push(this.chatgptMessageList[i]);
            if (i >= this.chatgptMessageList.length - 1) {
              continue;
            }
            if (
              this.chatgptMessageList[i].conversationId == null ||
              this.chatgptMessageList[i].conversationId !=
                this.chatgptMessageList[i + 1].conversationId
            ) {
              var newChatgptMessageEmpty = JSON.parse(
                JSON.stringify(this.chatgptMessageEmpty)
              );
              newChatgptMessageEmpty.id = i;
              newList.push(newChatgptMessageEmpty);
            }
          }
          this.chatgptMessageList = newList;
          this.count = res.data.total;
          if (isRunning == true) {
            if (this.isRunningPre != true) {
              this.isRunningPre = isRunning;
              this.openIntervalList();
            }
          } else {
            if (this.isRunningPre == true) {
              this.isRunningPre = isRunning;
              this.closeIntervalList();
            }
          }
          this.loading = false;

          this.getChatgptStat();

          // this.$nextTick(() => {
          //   this.attachClipboard();
          // });
        })
        .catch((err) => {
          this.loading = false;
          this.$store.state.loginFlag = false;
          // this.$toast({ type: "error", message: err.message });
          if (err.message === "请先登录!") {
            this.$store.state.loginFlag = true;
          } else {
            this.$notify({
              message: err.message,
              type: "error",
              showClose: true,
              position: "bottom-right",
              duration: 0,
            });
          }
          // this.$toast({ type: "error", message: "请先登录!" });
          // if(this.$store.state.avatar){
          //   this.$store.commit("logout");
          //   this.reload();
          // }
        });
    },

    checkIfAnswer: function(status) {
      if (status == "SUCCESS") {
        return "#49b1f5";
      } else if (status == "HIDE") {
        return "#76bff0";
      } else if (status == "FAILED") {
        return "#e29090";
      } else if (status == "RUNNING" || status == "RECEIVING") {
        return "#76d29f";
      } else {
        return "#cccccc";
      }
    },

    async submitAsk() {
      this.addRecentlyUsedModel(this.versionValue);
      // if (this.current == 1) {
      //   this.whichPage = 1;
      //   this.current = 1;
      // }
      if (this.input == null || this.input == "" || this.input.trim() == "") {
        this.$notify({
          message: "输入内容为空",
          type: "warning",
          showClose: false,
          position: "bottom-right",
          duration: 2000,
        });
        // this.$message({ type: "warning", message: "输入内容为空" });
        return;
      }

      this.continuousBreakDialogVisible = false;

      // 运行中检测
      if (this.chatgptMessageList.length >= 1) {
        if (
          (this.chatgptMessageList[0].status == "RUNNING" ||
            this.chatgptMessageList[0].status == "RECEIVING") &&
          this.isFollowLastOne === "true"
        ) {
          this.$notify({
            message: "当前还有正在运行中的提交，请等待；或者关闭连续会话再提交",
            type: "warning",
            showClose: false,
            position: "bottom-right",
            duration: 2000,
          });
          // this.$message({
          //   type: "warning",
          //   message: "当前还有正在运行中的提交，请等待；或者关闭连续会话再提交",
          // });
          return;
        }
      }

      this.loading = true;

      var parentMsgId;
      var conversationId;
      // console.log(this.chatgptMessageList);

      if (this.isFollowLastOne == "true") {
        if (this.chatgptMessageList.length >= 1) {
          parentMsgId = this.chatgptMessageList[0].msgId;
          conversationId = this.chatgptMessageList[0].conversationId;
        }
      }

      var tempInput = this.input.trim();
      this.input = "";

      //GPT4_API支持传图片
      var tempImgBase64StrList = null;
      if (this.hasModelFeature("upload-images")) {
        tempImgBase64StrList = this.imgBase64StrList;
      }

      // 获取文档ID列表
      const documentIds =
        this.uploadedDocs.length > 0
          ? this.uploadedDocs.map((doc) => doc.id).join(",")
          : null;

      const currentModel = getModelConfig(this.versionValue);

      const message = {
        role: this.getRole(),
        promptText: tempInput,
        parentMsgId: parentMsgId,
        conversationId: conversationId,
        gptVersion: this.versionValue,
        favorites: this.favoritesValue,
        continuousDialogMaxNum: this.continuousDialogMaxNum,
        imgBase64StrList: tempImgBase64StrList,
        documentIds: documentIds, // 添加文档ID参数
        status: "PENDING",
        completionText: "",
      };

      if (this.isEnableStream) {
        await this.handleStreamAsk(message);
      } else {
        await this.handleNormalAsk(message);
      }
    },
    openCharge() {
      this.continueAskQuotaDialogVisible = false;
      this.chargeDialogVisible = true;
    },
    submitBuyQuato() {
      precreateAlipay({
        subject:
          "购买AI问答配额" + this.chargeNum + "（+" + this.bonusNum + "）条",
        type: "CHATGPT_QUOTA",
        totalAmount: this.chargePrice,
      })
        .then((res) => {
          // console.log(res.data.qrCode);
          this.orderId = res.data.orderNo;
          QRCode.toDataURL(res.data.qrCode)
            .then((url) => {
              this.qrcodeImgUrl = url;
              this.isShowQrcodeSuccessImg = false;
              this.chargeStageText = "等待确认付款";
              // console.log(url)
              this.openIntervalGetChargeStatus();
            })
            .catch((err) => {
              console.error(err);
            });
        })
        .catch((err) => {
          this.$notify({
            message: "创建购买订单失败：" + err.message,
            type: "error",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
          // this.$toast({
          //   type: "error",
          //   message: "创建购买订单失败：" + err.message,
          // });
        });
    },

    // 图片上传组件
    oversize(file) {
      // this.$toast({
      //   type: "error",
      //   message:
      //     "图片过大，最大为12MB，当前为" + Math.floor(file.size / 1024) + "KB",
      // });
      this.$notify({
        message:
          "图片过大，最大为12MB，当前为" + Math.floor(file.size / 1024) + "KB",
        type: "warning",
        showClose: false,
        position: "bottom-right",
        duration: 4000,
      });
      // console.log('oversize')
      // console.log('filesize:' + file.size / 1024 + 'KB')
    },
    dataURItoBlob(data) {
      let byteString;
      if (data.split(",")[0].indexOf("base64") >= 0) {
        byteString = atob(data.split(",")[1]);
      } else {
        byteString = unescape(data.split(",")[1]);
      }

      let mimeString = data
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];
      let ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], {
        type: mimeString,
      });
    },
    // base64 格式
    getBase64(file) {
      return new Promise(function(resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function() {
          imgResult = reader.result;
        };
        reader.onerror = function(error) {
          reject(error);
        };
        reader.onloadend = function() {
          resolve(imgResult);
        };
      });
    },
    afterRead(file) {
      const fileFront = this.dataURItoBlob(file[0].url);
      new Promise((resolve, reject) => {
        // console.log("压缩前", file) // 压缩到 1MB，大于 1MB 的图片都会进行压缩，小于则不会
        imageConversion.compressAccurately(fileFront, 1024).then((res) => {
          res = new File([res], fileFront.name, {
            type: res.type,
            lastModified: Date.now(),
          });
          // console.log("压缩后", res)
          resolve(res);
        });
      }).then((responseRes) => {
        // console.log('after-read')
        this.getBase64(responseRes).then((response) =>
          this.imgBase64StrList.push(response)
        );
        // console.log(this.imgBase64StrList)
        // console.log(this.imgBase64StrList)
        // 上传图片至文件服务器
      });
    },

    beforeRemove(index, file) {
      // console.log(index, file)
      this.imgBase64StrList.splice(index, 1);
      // console.log(this.imgBase64StrList)
      return true;
    },

    preview(index, file) {
      this.previewIMG = file.url;
      this.isPreview = true;
    },
    clickUploadDocIcon() {
      // 实现文档上传逻辑
      // console.log("Upload document clicked");
      this.$refs.documentUploader.click();
    },
    async handleDocumentUpload(event) {
      const files = event.target.files;
      if (!files.length) return;

      // 检查文件类型
      for (let file of files) {
        const extension = file.name
          .split(".")
          .pop()
          .toLowerCase();
        if (!this.supportedDocTypes.includes(extension)) {
          this.$notify({
            title: "上传失败",
            message: `不支持的文件类型: ${file.name}`,
            type: "error",
          });
          event.target.value = "";
          return;
        }
      }

      this.uploading = true;
      const formData = new FormData();

      // 添加所有文件到 FormData
      for (let file of files) {
        formData.append("files", file);
      }

      try {
        const response = await uploadDocument(formData);

        // 直接检查 response 的状态
        if (response.code === 200) {
          // 或检查 response.success === true
          // 上传成功
          this.uploadedDocs = [...this.uploadedDocs, ...response.data];

          // 显示成功消息，包含文件信息
          // const fileNames = response.data.map((doc) => doc.fileName).join(", ");
          // const totalTokens = response.data.reduce(
          //   (sum, doc) => sum + doc.tokens,
          //   0
          // );

          // this.$notify({
          //   title: "上传成功",
          //   message: `已上传: ${fileNames}\n总计 tokens: ${totalTokens}`,
          //   type: "success",
          //   duration: 2000,
          //   showClose: true,
          //   position: "bottom-right",
          // });

          // 更新输入框
          // this.updateInputWithCurrentDocs();

          // 获取预估配额
          await this.updateDocsEstimatedQuota();
        }
      } catch (error) {
        this.$notify({
          title: "上传失败",
          message: error.message || "文件上传失败，请重试",
          type: "error",
          duration: 0,
          showClose: true,
          position: "bottom-right",
        });
      } finally {
        this.uploading = false;
        // 清空文件输入框的值，这样同一个文件可以重复选择
        event.target.value = "";
      }
    },
    getUploadDocClass() {
      // 返回文档上传按钮的样式类
      return {
        "upload-doc-active": true, // 可以根据需要添加条件
      };
    },

    clearInput() {
      this.input = "";
    },
    exceed() {
      alert(`只能上传${this.limit}张图片`);
    },

    beforeRead(files) {
      return true;
    },

    closePreview() {
      this.isPreview = false;
    },
    previewURL(src) {
      this.sourceImageURLs = [];
      this.sourceImageURLs.push(src);
      const $viewer = viewerApi({
        options: {
          navbar: false,
          toolbar: false,
          title: false,
          inline: true,
          button: true,
          tooltip: false,
          movable: true,
          zoomable: true,
          rotatable: true,
          scalable: true,
          transition: true,
          fullscreen: true,
          keyboard: false,
        },
        images: this.sourceImageURLs,
      });
    },
    // 更新文档预估配额
    async updateDocsEstimatedQuota() {
      if (!this.uploadedDocs.length) return;

      try {
        const docIds = this.uploadedDocs.map((doc) => doc.id).join(",");
        const response = await estimateDocumentTokens({
          documentIds: docIds,
          gptVersion: this.versionValue,
        });

        if (response.code === 200) {
          // 更新每个文档的预估配额
          const estimations = response.data;
          this.uploadedDocs = this.uploadedDocs.map((doc) => {
            const estimation = estimations.find(
              (est) => est.documentId === doc.id
            );
            return {
              ...doc,
              estimatedQuota: estimation ? estimation.estimatedQuota : null,
            };
          });
        }
      } catch (error) {
        console.error("获取预估配额失败:", error);
      }
    },
    handleDragOver(e) {
      this.isDragOver = true;
      e.dataTransfer.dropEffect = "copy";
    },
    handleDragLeave() {
      this.isDragOver = false;
    },
    handleDrop(e) {
      this.isDragOver = false;

      // 检查是否为 GPT-3.5 模型
      if (this.versionValue === "GPT3_5_API") {
        this.$notify({
          title: "功能限制",
          message: "GPT-3.5 模型不支持文件上传功能",
          type: "warning",
          showClose: false,
          position: "bottom-right",
          duration: 2000,
        });
        return;
      }

      const files = Array.from(e.dataTransfer.files);

      if (files.length > 0) {
        files.forEach((file) => {
          const extension = file.name
            .split(".")
            .pop()
            .toLowerCase();

          if (this.supportedImageTypes.includes(extension)) {
            // 处理图片文件
            this.handleImageUpload({ target: { files: [file] } });
          } else if (this.supportedDocTypes.includes(extension)) {
            // 处理文档文件
            this.handleDocumentUpload({ target: { files: [file] } });
          } else {
            this.$notify({
              title: "不支持的文件类型",
              message: `不支持上传 ${extension} 类型的文件`,
              type: "warning",
              showClose: false,
              position: "bottom-right",
              duration: 2000,
            });
          }
        });
      }
    },

    // 可以添加一个提示方法来显示支持的文件类型
    showSupportedTypes() {
      return {
        images: this.supportedImageTypes.join(", "),
        documents: this.supportedDocTypes.join(", "),
      };
    },
    enableContinuousDialog() {
      this.isFollowLastOne = "true";
      this.followSwitchChange();
    },
    hasModelFeature(feature) {
      return hasFeature(this.versionValue, feature);
    },
    hasSelectedModelFeature(versionValue, feature) {
      return hasFeature(versionValue, feature);
    },
    getGptVersion(version) {
      return getModelDisplayName(version);
    },
    async handleStreamAsk(message) {
      try {
        const response = await askChatgptStream(message);
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        var utf8decoder = new TextDecoder();
        let buffer = "";
        let messageId = null;

        // 处理单个SSE事件
        const processEvent = (eventData) => {
          // 解析事件名称和数据
          const eventLines = eventData.split("\n");
          // console.log(eventLines);
          let eventName = "";
          let eventPayload = "";

          for (const line of eventLines) {
            if (line.startsWith("event:")) {
              eventName = line.replace("event:", "").trim();
            } else if (line.startsWith("data:")) {
              eventPayload = line.replace("data:", "");
            }
          }
          // console.log(eventName);
          // console.log(eventPayload);

          // 根据事件类型处理数据
          switch (eventName) {
            case "init":
              messageId = eventPayload;
              // 发送新消息时，需要设置当前分页为1，如果用户再其他分页的话跳转到第一分页
              this.current = 1;
              this.listChatgptMessageWithLoading();
              this.$notify({
                message: "发送成功！",
                type: "success",
                showClose: false,
                position: "bottom-right",
                duration: 2000,
              });
              // this.$message({ type: "success", message: "发送成功" });
              this.getChatgptStat();
              break;
            case "reasoning":
              {
                // 添加空值检查
                if (!eventPayload) {
                  console.warn("Received empty payload for event:", eventName);
                  break;
                }
                // Base64解码
                var decoded = atob(eventPayload);
                var content = utf8decoder.decode(
                  new Uint8Array([...decoded].map((c) => c.charCodeAt(0)))
                );
                this.appendReasoning(messageId, content); // 直接使用文本内容
              }
              break;
            case "message":
              {
                // 添加空值检查
                if (!eventPayload) {
                  console.warn("Received empty payload for event:", eventName);
                  break;
                }
                // Base64解码
                var decoded1 = atob(eventPayload);
                var content1 = utf8decoder.decode(
                  new Uint8Array([...decoded1].map((c) => c.charCodeAt(0)))
                );
                this.appendContent(messageId, content1); // 直接使用文本内容
              }
              break;
            case "complete":
              this.finalizeMessage(messageId);
              break;
            case "error":
              {
                // Base64解码
                var decoded2 = atob(eventPayload);
                var content2 = utf8decoder.decode(
                  new Uint8Array([...decoded2].map((c) => c.charCodeAt(0)))
                );
                this.input = message.promptText;
                this.showError(messageId, content2);
              }
              break;

            default:
              console.warn("Unknown event type:", eventName);
          }
        };

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });

          // 处理多事件情况
          while (buffer.includes("\n\n")) {
            const eventEndIndex = buffer.indexOf("\n\n");
            const eventData = buffer.substring(0, eventEndIndex);
            buffer = buffer.substring(eventEndIndex + 2);

            if (eventData.trim()) {
              processEvent(eventData);
            }
          }
        }
      } catch (error) {
        this.handleStreamError(error);
      }
    },

    async handleNormalAsk(message) {
      askChatgpt(message)
        .then((res) => {
          // 发送新消息时，需要设置当前分页为1，如果用户再其他分页的话跳转到第一分页
          this.current = 1;
          this.listChatgptMessageWithLoading();
          this.$notify({
            message: "发送成功！",
            type: "success",
            showClose: false,
            position: "bottom-right",
            duration: 2000,
          });
          // this.$message({ type: "success", message: "发送成功" });
          this.getChatgptStat();
        })
        .catch((err) => {
          this.loading = false;
          // 发送失败，不要删除已填入的字符
          this.input = message.promptText;
          var messageClass = "hideChargeBtnClass";
          if (err.message.indexOf("充值") != -1) {
            messageClass = "showChargeBtnClass";
          }
          const h = this.$createElement;
          this.$notify({
            dangerouslyUseHTMLString: true,
            message: h("div", [
              h(
                "p",
                {
                  style: "margin-bottom:0px !important",
                },
                "发送失败！"
              ),
              h(
                "p",
                {
                  style: "margin-bottom:0px !important",
                },
                err.message
              ),
              h(
                "div",
                {
                  class: messageClass,
                },
                [
                  h(
                    "el-button",
                    {
                      on: {
                        click: this.openCharge,
                      },
                    },
                    "购买配额"
                  ),
                ]
              ),
            ]),
            // message: "<span>发送失败！</span><br>" + messageStr,
            type: "error",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
        });
    },

    getCurrentMessageIndex(messageId) {
      return this.chatgptMessageList.findIndex((msg) => msg.id === messageId);
    },
    getCurrentMessage(messageId) {
      return this.chatgptMessageList.find((msg) => msg.id === messageId);
    },
    dealMarkdownBlock(messageId, text, isForceMath = false) {
      if (!text) {
        return "";
      }

      // 预处理绘图响应
      if (
        text.includes('"prompt":') ||
        text.includes('"referenced_image_ids":')
      ) {
        // console.log(text);
        // 先移除所有包含 ``` 的行
        let processedText = text
          .split("\n")
          .filter((line) => !line.includes("```"))
          .join("\n");
        // 1. 提取并处理JSON部分
        const jsonMatch = processedText.match(/\{[\s\S]*?\}/);

        if (jsonMatch) {
          try {
            const jsonData = JSON.parse(jsonMatch[0]);
            // 只保留prompt内容
            var info = "";
            if (jsonData.prompt) {
              info += "**prompt**: " + jsonData.prompt + "\n";
            }
            if (jsonData.referenced_image_ids) {
              info +=
                "**referenced_image_ids**: " +
                jsonData.referenced_image_ids +
                "\n";
            }
            if (jsonData.size) {
              info += "**size**: " + jsonData.size + "\n";
            }
            processedText = processedText.replace(jsonMatch[0], info);
          } catch (e) {
            // console.error("JSON parse error:", e);
          }
        }

        // 2. 处理进度信息 - 只保留最后一个进度
        const lines = processedText.split("\n");
        const progressLines = lines.filter((line) =>
          line.trim().startsWith("> 进度")
        );
        const otherLines = lines.filter(
          (line) => !line.trim().startsWith("> 进度")
        );

        if (progressLines.length > 0) {
          if (processedText.includes("下载")) {
            processedText = [...otherLines].join("\n");
          } else {
            // 只保留最后一个进度行
            processedText = [
              ...otherLines,
              progressLines[progressLines.length - 1],
            ].join("\n");
          }
        }
        text = processedText;
      }
      // 3. 进行常规的markdown渲染
      const html = this.formatResponse(text);

      // 如果需要处理MathJax
      if (isForceMath) {
        this.formatMath(messageId);
      }

      return html;
    },

    formatResponse(text) {
      if (!text) {
        return "";
      }
      // console.log(text);
      // 1. 先保护所有LaTeX标记，并移除公式内的换行
      let protectedText = text
        // 处理段内公式 $$...$$，移除换行
        .replace(/\$\$([\s\S]*?)\$\$/g, (match, formula) => {
          return `§DDOLLAR§${formula
            .replace(/\n/g, "§LINEBREAK§")
            .replace(/&/g, "§AND§")
            .replace(/\\\\/g, "§SLASHSLASH§")}§DDOLLAREND§`;
        })
        // 处理行内公式 $...$
        .replace(/\$([^\$\n]+?)\$/g, (match, formula) => {
          return `§DOLLAR§${formula
            .replace(/\n/g, "§LINEBREAK§")
            .replace(/&/g, "§AND§")
            .replace(/\\\\/g, "§SLASHSLASH§")}§DOLLAREND§`;
        })
        // 处理行内公式 \(...\)
        .replace(/\\\(([\s\S]*?)\\\)/g, (match, formula) => {
          return `§BRACKET§${formula
            .replace(/\n/g, "§LINEBREAK§")
            .replace(/&/g, "§AND§")
            .replace(/\\\\/g, "§SLASHSLASH§")}§BRACKETEND§`;
        })
        // 处理段内公式 \[...\]，移除换行
        .replace(/\\\[([\s\S]*?)\\\]/g, (match, formula) => {
          return `§SQUARE§${formula
            .replace(/\n/g, "§LINEBREAK§")
            .replace(/&/g, "§AND§")
            .replace(/\\\\/g, "§SLASHSLASH§")}§SQUAREEND§`;
        })
        // 处理段内公式 _{..._{
        .replace(/_\{([\s\S]*?)_\{/g, (match, formula) => {
          return `§UNDERLINE§${formula}§UNDERLINEEND§`;
        });
      // console.log(protectedText);
      // 2. marked处理
      const renderer = new marked.Renderer();
      renderer.code = (code, language = "plaintext") => {
        const validLanguage = Prism.languages[language]
          ? language
          : "plaintext";

        // 生成行号
        const lines = code.trim().split("\n");
        const lineNumbersHtml = lines
          .map((_, index) => `<span></span>`)
          .join("");

        // 代码高亮
        const highlightedCode = Prism.highlight(
          code.trim(),
          Prism.languages[validLanguage],
          validLanguage
        );

        // 注意这里的HTML结构，移除了多余的空格和换行
        return `<div class="code-block">
            <div class="code-header">
              <span class="code-language">${
                validLanguage == "plaintext"
                  ? language + "(plaintext)"
                  : validLanguage
              }</span>
              <button class="copy-button" onclick="window.copyCode(this)" data-code="${encodeURIComponent(
                code
              )}">
                <i class="el-icon-document-copy"></i>
                <span>复制</span>
              </button>
            </div>
            <pre class="line-numbers language-${validLanguage}"><code>${highlightedCode}</code><span aria-hidden="true" class="line-numbers-rows">${lineNumbersHtml}</span></pre>
          </div>`;
      };

      marked.setOptions({
        renderer: renderer,
        highlight: null,
        breaks: true,
        gfm: true,
        headerIds: false,
      });
      let html = marked.parse(protectedText);
      // console.log(html);
      // 3. 恢复所有LaTeX标记
      html = html
        .replace(
          /§DDOLLAR§([\s\S]*?)§DDOLLAREND§/g,
          (_, content) => `<span class="math-block">$$${content}$$</span>`
        )
        .replace(
          /§DOLLAR§([\s\S]*?)§DOLLAREND§/g,
          (_, content) => `<span class="math-inline">$${content}$</span>`
        )
        .replace(
          /§BRACKET§([\s\S]*?)§BRACKETEND§/g,
          (_, content) => `<span class="math-inline">\\(${content}\\)</span>`
        )
        .replace(
          /§SQUARE§([\s\S]*?)§SQUAREEND§/g,
          (_, content) => `<span class="math-block">\\[${content}\\]</span>`
        )
        .replace(/§UNDERLINE§([\s\S]*?)§UNDERLINEEND§/g, "_{$1_{")
        .replace(/§LINEBREAK§/g, "\n")
        .replace(/§AND§/g, "&")
        .replace(/§SLASHSLASH§/g, "\\\\");

      // console.log(html);
      return html;
    },
    formatCode(code, language) {
      try {
        // 确保语言支持已加载
        if (Prism.languages[language]) {
          return Prism.highlight(code, Prism.languages[language], language);
        }
        // 如果没有找到语言支持，返回原始代码
        return code;
      } catch (error) {
        console.warn("Code highlighting failed:", error);
        return code;
      }
    },
    dealMarkdownBlock2(messageId, content, isForceMath = false) {
      var count = content.split("```").length - 1;

      if (count % 2 == 1) {
        if (content.indexOf("```") == content.indexOf("```\r\n")) {
          // 说明代码是代码块中断的后半段
          content = "```\r\n" + content;
        } else {
          content = content + "\r\n```";
        }
      }

      // 处理代码块
      // console.log(item.completionText);
      if (content.indexOf("```") != -1) {
        // item.completionText = this.dealStrWithCode(item.completionText);
      }

      // console.log(item.completionText);
      // 处理返回latex不以$形式出现的问题
      content = this.solveMathjax(content);

      if (
        content != null &&
        (content.search(/\$([^\\r\\n])+\$/) != -1 ||
          content.search(/\$\$/) != -1)
      ) {
        content = this.solveMarkdownAndMathjax(content);
        if (isForceMath) {
          this.formatMath(messageId);
        }
        content = marked.parse(content);
      } else {
        content = marked.parse(content);
      }

      return content;
    },
    appendReasoning(messageId, content) {
      // 实现内容追加逻辑，例如：
      const index = this.getCurrentMessageIndex(messageId);
      if (!this.reasoningCache.has(messageId)) {
        this.reasoningCache.set(messageId, "");
      }
      this.reasoningCache.set(
        messageId,
        this.reasoningCache.get(messageId) + content
      );
      if (index === -1) {
        return;
      }

      var message = this.chatgptMessageList[index];

      if (!message.reasoningTextOrigin) {
        message.reasoningTextOrigin = "";
        if (this.reasoningCache.has(messageId)) {
          var reasoningTextOriginCache = this.reasoningCache.get(messageId);
          message.color = this.checkIfAnswer("RECEIVING");
          message.reasoningTextOrigin = reasoningTextOriginCache;
        }
      } else {
        message.reasoningTextOrigin += content;
      }

      var newContent = this.dealMarkdownBlock(
        messageId,
        message.reasoningTextOrigin,
        false
      );

      const updatedMessage = {
        ...message,
        reasoningText: newContent,
      };

      this.$set(this.chatgptMessageList, index, updatedMessage);
    },

    appendContent(messageId, content) {
      // 实现内容追加逻辑，例如：
      const index = this.getCurrentMessageIndex(messageId);
      if (!this.streamCache.has(messageId)) {
        this.streamCache.set(messageId, "");
      }
      this.streamCache.set(
        messageId,
        this.streamCache.get(messageId) + content
      );
      if (index === -1) {
        return;
      }

      var message = this.chatgptMessageList[index];
      // if (!message.reasoningText && this.reasoningCache.has(messageId)) {
      //   this.appendReasoning(messageId, "");
      // }

      if (!message.streamingTextOrigin) {
        message.streamingTextOrigin = "";
        if (this.streamCache.has(messageId)) {
          var streamingTextOriginCache = this.streamCache.get(messageId);
          message.color = this.checkIfAnswer("RECEIVING");
          message.streamingTextOrigin = streamingTextOriginCache;
        }
      } else {
        message.streamingTextOrigin += content;
      }

      var newContent = this.dealMarkdownBlock(
        messageId,
        message.streamingTextOrigin,
        false
      );

      // console.log(newContent);
      // 创建新对象触发响应式更新

      const updatedMessage = {
        ...message,
        streamingText: newContent,
      };

      this.$set(this.chatgptMessageList, index, updatedMessage);
    },

    finalizeMessage(messageId) {
      // 标记消息完成，例如：
      const currentMessage = this.getCurrentMessage(messageId);
      if (currentMessage) {
        currentMessage.completionText = this.dealMarkdownBlock(
          messageId,
          currentMessage.streamingTextOrigin,
          true
        );
        currentMessage.streamingText = "";
        currentMessage.streamingTextOrigin = "";
        currentMessage.status = "SUCCESS";

        currentMessage.color = this.checkIfAnswer("SUCCESS");
      }
      this.streamCache.delete(messageId);
      this.reasoningCache.delete(messageId);
      this.listChatgptMessage();
      this.getChatgptStat();
    },

    cancelStream() {
      // 取消流式请求的清理逻辑
      if (this.reader) {
        this.reader.cancel();
        this.reader = null;
      }
    },

    handleStreamError(error) {
      // 统一错误处理
      console.error("Stream error:", error);
      this.$notify({
        title: "连接异常",
        message: "实时对话连接中断，请重试",
        type: "error",
        showClose: true,
        position: "bottom-right",
      });
    },

    showError(messageId, errorMessage) {
      const currentMessage = this.getCurrentMessage(messageId);
      if (currentMessage) {
        currentMessage.status = "FAILED";
      }

      // 使用 Element UI 的通知组件显示错误
      var messageClass = "hideChargeBtnClass";

      if (errorMessage.indexOf("充值") != -1) {
        messageClass = "showChargeBtnClass";
      }
      const h = this.$createElement;
      this.$notify({
        dangerouslyUseHTMLString: true,
        message: h("div", [
          h(
            "p",
            {
              style: "margin-bottom:0px !important",
            },
            "发送失败！"
          ),
          h(
            "p",
            {
              style: "margin-bottom:0px !important",
            },
            errorMessage
          ),
          h(
            "div",
            {
              class: messageClass,
            },
            [
              h(
                "el-button",
                {
                  on: {
                    click: this.openCharge,
                  },
                },
                "购买配额"
              ),
            ]
          ),
        ]),
        // message: "<span>发送失败！</span><br>" + messageStr,
        type: "error",
        showClose: true,
        position: "bottom-right",
        duration: 0,
      });

      this.listChatgptMessageWithLoading();
    },
    // 处理导出
    async handleExport(type, item) {
      const title = this.generateExportFileName(item.promptText);
      const originContent = item.completionTextOrigin;
      const content = item.completionText;

      switch (type) {
        case "txt":
          this.exportTxt(title, originContent);
          break;
        case "md":
          this.exportMarkdown(title, originContent);
          break;
        case "pdf":
          await this.exportPdf(title, originContent);
          break;
        case "doc":
          this.exportWord(title, originContent);
          break;
      }
    },

    // 导出为 TXT
    exportTxt(title, content) {
      const text = this.stripHtml(content);
      const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
      saveAs(blob, `${title}.txt`);
    },

    // 导出为 Markdown
    exportMarkdown(title, content) {
      // 保持原始 markdown 格式
      const blob = new Blob([content], { type: "text/markdown;charset=utf-8" });
      saveAs(blob, `${title}.md`);
    },

    // 导出为 PDF（使用原始Markdown生成更专业的排版）
    async exportPdf(title, originContent) {
      try {
        // 将Markdown转换为带样式的HTML
        const content = this.markdownToFormattedHtml(originContent);

        const element = document.createElement("div");
        element.innerHTML = content;
        element.style.padding = "20px";
        element.style.fontFamily = "'SimSun', sans-serif";
        element.style.lineHeight = "1.6";

        // 添加打印样式
        const style = document.createElement("style");
        style.innerHTML = `
          h1 { font-size: 24px; margin: 20px 0; border-bottom: 2px solid #333; }
          h2 { font-size: 20px; margin: 18px 0; }
          p { margin: 10px 0; text-align: justify; }
          pre {
            background: #f5f5f5;
            padding: 15px;
            border-radius: 4px;
            overflow: auto;
            margin: 10px 0;
            border: 1px solid #ddd;
          }
          code { font-family: Consolas, monospace; }
          table {
            width: 100%;
            border-collapse: collapse;
            margin: 15px 0;
          }
          th, td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
          }
          th {
            background-color: #f5f5f5;
          }
          img {
            max-width: 100%;
            height: auto;
            margin: 10px 0;
          }
        `;
        element.appendChild(style);

        const opt = {
          margin: [10, 15], // [垂直, 水平]
          filename: `${title}.pdf`,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: {
            scale: 2,
            useCORS: true,
            logging: true,
          },
          jsPDF: {
            unit: "mm",
            format: "a4",
            orientation: "portrait",
            hotfixes: ["px_scaling"],
          },
          pagebreak: {
            mode: "avoid-all",
            before: ".page-break",
          },
        };

        await html2pdf()
          .set(opt)
          .from(element)
          .save();
        element.remove();
      } catch (error) {
        this.$message.error("PDF导出失败，请重试");
        console.error("PDF export error:", error);
      }
    },

    // 生成导出文件名
    generateExportFileName(title) {
      const date = new Date();
      const dateStr =
        date.getFullYear() +
        String(date.getMonth() + 1).padStart(2, "0") +
        String(date.getDate()).padStart(2, "0");

      return `Seayouth_${dateStr}_${this.simplifyHistoryItem(title, 20)}`;
    },

    // 导出为 Word（使用专业样式模板）
    async exportWord(title, originContent) {
      try {
        // 将Markdown转换为带样式的HTML
        const content = this.markdownToFormattedHtml(originContent);

        // 专业Word模板
        const htmlContent = `
          <!DOCTYPE html>
          <html>
          <head>
            <meta charset="UTF-8">
            <title>${title}</title>
            <style>
              body {
                font-family: 'Times New Roman', SimSun, sans-serif;
                line-height: 1.5;
                margin: 2.54cm 3.17cm; /* 标准页边距 */
              }
              h1 { 
                font-size: 16pt; 
                margin: 24pt 0 12pt;
                border-bottom: 1pt solid #000;
                padding-bottom: 3pt;
              }
              h2 { font-size: 14pt; margin: 18pt 0 9pt; }
              p { 
                margin: 0 0 12pt; 
                text-indent: 2em;
                text-align: justify;
              }
              pre {
                background: #f5f5f5;
                border: 0.5pt solid #ddd;
                padding: 12pt;
                margin: 12pt 0;
                page-break-inside: avoid;
              }
              code { font-family: Consolas, monospace; }
              table {
                width: 100%;
                border-collapse: collapse;
                margin: 12pt 0;
                page-break-inside: avoid;
              }
              th, td {
                border: 0.5pt solid #000;
                padding: 6pt;
                text-align: left;
              }
              th {
                background-color: #e8e8e8;
              }
              img {
                max-width: 100%;
                height: auto;
                margin: 12pt 0;
                page-break-inside: avoid;
              }
              .page-break {
                page-break-before: always;
              }
            </style>
          </head>
          <body>${content}</body>
          </html>
        `;

        const blob = new Blob([htmlContent], {
          type:
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });
        saveAs(blob, `${title}.docx`);
      } catch (error) {
        this.$message.error("Word导出失败，请重试");
        console.error("DOCX export error:", error);
      }
    },

    // 辅助方法：去除HTML标签
    stripHtml(html) {
      const tmp = document.createElement("div");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },

    // Markdown转格式化HTML（带专业样式）
    markdownToFormattedHtml(markdown) {
      const renderer = new marked.Renderer();

      // 自定义渲染规则
      renderer.heading = (text, level) => {
        const tag = `h${level}`;
        return `<${tag} style="margin:${24 - level * 4}pt 0 ${12 -
          level * 2}pt">${text}</${tag}>`;
      };

      renderer.code = (code, language) => {
        const validLang = Prism.languages[language] ? language : "plaintext";
        const highlighted = Prism.highlight(
          code,
          Prism.languages[validLang],
          validLang
        );
        return `<pre><code class="language-${validLang}">${highlighted}</code></pre>`;
      };

      renderer.table = (header, body) => {
        return `<table style="border-collapse: collapse; width: 100%; margin: 12pt 0;">
          <thead>${header}</thead>
          <tbody>${body}</tbody>
        </table>`;
      };

      marked.setOptions({
        renderer,
        breaks: false,
        gfm: true,
        smartLists: true,
        smartypants: true,
      });

      return marked.parse(markdown);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },

    scrollToBottom() {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth",
      });
    },

    truncateText(text, length) {
      if (!text) return "";
      return text.length > length ? text.slice(0, length) + "..." : text;
    },

    getValidMessageNumber(currentIndex) {
      return this.chatgptMessageList
        .slice(0, currentIndex + 1)
        .filter((msg) => msg.status !== "SLASH").length;
    },

    togglePagination() {
      this.showPagination = !this.showPagination;
      localStorage.setItem("chatgpt_showPagination", this.showPagination);
    },

    // 切换搜索框显示
    toggleSearch() {
      this.showSearch = !this.showSearch;
      if (!this.showSearch) {
        this.searchQuery = "";
        this.searchResults = [];
      }
    },

    // 处理搜索输入
    handleSearchInput() {
      // 清除之前的定时器
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }

      // 设置新的定时器
      this.searchDebounceTimer = setTimeout(() => {
        this.performSearch();
      }, 1000);
    },

    // 执行搜索
    async performSearch() {
      if (!this.searchQuery.trim()) {
        this.searchResults = [];
        return;
      }

      this.searchLoading = true;
      try {
        const response = await searchChatgptMessages({
          pageNum: 1,
          pageSize: 10,
          q: this.searchQuery,
        });
        this.searchResults = response.data;
      } catch (error) {
        console.error("搜索失败:", error);
        this.$notify({
          message: "搜索失败，请重试",
          type: "error",
          position: "bottom-right",
        });
      } finally {
        this.searchLoading = false;
      }
    },

    waitForLoading() {
      return new Promise((resolve) => {
        const checkLoading = () => {
          if (!this.loading) {
            resolve();
          } else {
            setTimeout(checkLoading, 100); // 每100ms检查一次
          }
        };
        checkLoading();
      });
    },

    // 修改原有的滚动代码
    async scrollToMessage(item) {
      await this.waitForLoading(); // 等待 loading 结束
      this.$nextTick(() => {
        // console.log("scrollToMessage:" + item.id);
        const element = document.getElementById(item.id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },

    // 处理搜索结果点击
    async handleSearchResultClick(item) {
      try {
        const response = await getChatgptMessagePosition(
          item.id,
          this.$store.state.configInfo.chatgpt.pageSize
        );
        const { pageNo, position } = response.data;

        // console.log(pageNo, position);
        // 更新页码并关闭搜索
        this.current = pageNo;
        this.showSearch = false;
        this.searchQuery = "";
        this.searchResults = [];
        // 重置收藏夹,这样才能准确跳转
        this.favoritesValue = 0;
        // console.log("listChatgptMessageWithLoading");
        this.loading = true;
        await this.listChatgptMessageWithLoading();
        // console.log("listChatgptMessageWithLoading end");
        // 等待页面数据加载完成后滚动到目标消息
        this.scrollToMessage(item);
      } catch (error) {
        console.error("获取消息位置失败:", error);
        this.$notify({
          message: "获取消息位置失败，请重试",
          type: "error",
          position: "bottom-right",
        });
      }
    },
    handleSearchBlur() {
      // 使用 setTimeout 是为了让点击搜索结果的事件能够先触发
      setTimeout(() => {
        this.isSearchFocused = false;
      }, 200);
    },

    handleSearchFocus() {
      this.isSearchFocused = true;
    },

    // 获取特性的显示名称
    getFeatureDisplayName(feature) {
      const displayNames = {
        reasoning: "💡思考",
        deepsearch: "🌍联网搜索",
        mini: "🚀快速",
        new: "✨新上线",
        streaming: "🔄流式",
        "upload-docs": "📄上传文档",
        "upload-images": "🖼️上传图片",
        // roles: "👥角色扮演",
        cheap: "🔥便宜",
        draw: "🎨绘图",
        // 可以根据需要添加更多特性的显示名称
      };
      return displayNames[feature] || feature;
    },

    // 根据选择的features过滤模型
    filterModelsByFeatures(event) {
      // If event is provided, it means user clicked on checkboxes
      if (event && Array.isArray(event)) {
        this.selectedFeatures = event;
      }

      let sourceModels = [...this.originalVersionOptions];

      // Step 1: Filter by "Recently Used" if selected
      const recentlyUsedSelected = this.selectedFeatures.includes(
        "recently-used"
      );

      if (recentlyUsedSelected) {
        const recentModelValues = new Set(this.recentlyUsedModels);
        sourceModels = sourceModels.filter((modelOption) =>
          recentModelValues.has(modelOption.value)
        );
      }

      // Step 2: Filter by other features
      const otherFeatures = this.selectedFeatures.filter(
        (f) => f !== "recently-used"
      );
      if (otherFeatures.length > 0) {
        this.filteredVersionOptions = sourceModels.filter((modelOption) => {
          const model = this.allModelsMap[modelOption.value];
          if (!model) return false;

          // Check if the model has ALL other selected features
          return otherFeatures.every((feature) =>
            hasFeature(modelOption.value, feature)
          );
        });
      } else {
        this.filteredVersionOptions = sourceModels;
      }

      this.saveSelectedFeatures();
    },

    // 加载保存的特性选择
    loadSelectedFeatures() {
      const savedFeatures = localStorage.getItem("chatgpt_selectedFeatures");
      if (savedFeatures) {
        try {
          this.selectedFeatures = JSON.parse(savedFeatures);
        } catch (e) {
          console.error("解析已选特性失败:", e);
          this.selectedFeatures = [];
        }
      } else {
        this.selectedFeatures = [];
      }
    },

    // 保存特性选择到localStorage
    saveSelectedFeatures() {
      try {
        localStorage.setItem(
          "chatgpt_selectedFeatures",
          JSON.stringify(this.selectedFeatures)
        );
      } catch (e) {
        console.error("保存已选特性失败:", e);
      }
    },
    handlePaste(event) {
      // 获取剪贴板数据
      const clipboardData = event.clipboardData || window.clipboardData;

      // 检查是否有文件
      if (
        clipboardData &&
        clipboardData.files &&
        clipboardData.files.length > 0
      ) {
        const files = clipboardData.files;

        // 检查是否包含图片文件
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          if (this.isImageFile(file)) {
            // 阻止默认粘贴行为
            event.preventDefault();

            // 直接使用handleImageUpload方法处理图片
            const fakeEvent = { target: { files: [file] } };
            this.handleImageUpload(fakeEvent);
            return;
          }
        }
      }

      // 检查是否有剪贴板中的图片数据
      if (clipboardData && clipboardData.items) {
        for (let i = 0; i < clipboardData.items.length; i++) {
          const item = clipboardData.items[i];

          // 检查是否是图片类型
          if (item.type.indexOf("image") !== -1) {
            // 阻止默认粘贴行为
            event.preventDefault();

            // 从剪贴板项中获取文件
            const file = item.getAsFile();
            if (file) {
              // 为粘贴的图片创建唯一文件名
              const timestamp = new Date().getTime();
              const filename = `pasted_image_${timestamp}.png`;

              // 创建带有自定义文件名的新File对象
              const renamedFile = new File([file], filename, {
                type: file.type,
              });

              // 直接使用handleImageUpload方法处理图片
              const fakeEvent = { target: { files: [renamedFile] } };
              this.handleImageUpload(fakeEvent);
            }
            return;
          }
        }
      }
    },

    handleImageFile(file) {
      if (this.oversize(file)) {
        this.$message.error(`文件大小不能超过${this.fileMaxSize}MB!`);
        return;
      }

      // 使用现有的getBase64方法处理图片
      this.getBase64(file).then((res) => {
        // 创建一个与afterRead期望的格式一致的对象
        const fileObj = {
          content: res,
          file: file,
          name: file.name,
          url: res, // 添加url属性，它应该是base64数据
        };

        // 调用现有的图片上传处理方法
        this.afterRead(fileObj);
      });
    },
  },
  computed: {
    cover() {
      var cover = "";
      this.$store.state.blogInfo.pageList.forEach((item) => {
        if (item.pageLabel === "chatgpt") {
          cover = item.pageCover;
        }
      });
      return "background: url(" + cover + ") center center / cover no-repeat";
    },
    isMobile() {
      const clientWidth = document.documentElement.clientWidth;
      if (clientWidth > 760) {
        return false;
      }
      return true;
    },
    isEnableStream() {
      return this.$store.state.configInfo?.chatgpt?.enableStream ?? true;
    },
  },
  watch: {
    current(value) {
      this.current = value;
      this.loading = true;
      this.listChatgptMessageWithLoading();
    },
  },
};
